export default __webpack_public_path__ + "static/media/tick.63d11d53.svg";